export default __webpack_public_path__ + "static/media/a4.61b855c3.png";